var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('y-loading',{attrs:{"active":_vm.$wait.is('loading-node-details'),"height":"100px"}},[(_vm.content)?_c('div',{staticClass:"content"},[_c('y-order-edition-diff',{attrs:{"content":_vm.content}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }